import { IGif } from "services/types";
import { useLocation } from "react-router";
import { getMoreMenuData } from "./menus";
import { useVisitorInfo } from "hooks";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { IAppState } from "store/app-state";
import { Roles } from "components/dialogs/EditNichesDialog/hooks";
import { MoreMenu } from "./MoreMenu";

interface IMoreMenuContainerProps {
  gif: IGif;
  anchorEl: HTMLElement | null;
  handleCloseMenu: () => void;
  fullscreen?: boolean;
  handleHideGif: (gif: IGif) => void;
  handleManageClick: (gif: IGif) => void;
  handleOpenEditNichesDialog: (role: Roles) => void;
  toggleCollection: () => void;
  toggleNiche: (gif: string) => void;
  toggleReport: () => void;
  toggleShareMenu: (event: React.MouseEvent<HTMLButtonElement>) => void;
  toggleGifPrefs: () => void;
}

export const MoreMenuContainer: React.FC<IMoreMenuContainerProps> = (props) => {
  const {
    gif,
    anchorEl,
    handleCloseMenu,
    fullscreen,
    handleHideGif,
    handleManageClick,
    handleOpenEditNichesDialog,
    toggleCollection,
    toggleNiche,
    toggleReport,
    toggleShareMenu,
    toggleGifPrefs
  } = props;

  const myNiches = useSelector((state: IAppState) => state.user.myNiches);
  const currentUser = useVisitorInfo();

  const location = useLocation();

  const isNicheContentModerator = useMemo(() => {
    const pathNameSplit = location.pathname.split("/");
    const nicheId = pathNameSplit.pop();
    const pageName = pathNameSplit.pop();
    let isModerator = false;

    if (pageName !== "niches") {
      return isModerator;
    }

    myNiches.forEach(({ id }) => {
      if (id === nicheId) {
        isModerator = true;
      }
    });

    return isModerator;
  }, [location, myNiches]);

  const actions = {
    handleHideGif,
    handleManageClick,
    handleOpenEditNichesDialog,
    toggleCollection,
    toggleNiche,
    toggleReport,
    toggleShareMenu,
    toggleGifPrefs,
  };

  const moreMenuData = getMoreMenuData({
    actions,
    currentUser,
    gif: gif,
    isNicheContentModerator,
  });

  return (
    <MoreMenu
      isOpen
      anchorEl={anchorEl}
      onClose={handleCloseMenu}
      menuItems={moreMenuData}
      isFullscreen={fullscreen}
    />
  );
};
